import { createAction, createSlice } from "@reduxjs/toolkit";

type valueType = { targetCandidateId: number } | null;

export const setIsReconsiderCandidateDialogOpen = createAction<
  valueType,
  "setIsReconsiderCandidateDialogOpen"
>("setIsReconsiderCandidateDialogOpen");

const isReconsiderCandidateDialogOpenSlice = createSlice({
  name: "isReconsiderCandidateDialogOpen",
  initialState: null as valueType,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(
      setIsReconsiderCandidateDialogOpen,
      (state, { payload }) => {
        return payload;
      }
    );
  },
});

export default isReconsiderCandidateDialogOpenSlice.reducer;
